import React, { useEffect } from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import ConnectedAuthNotification from '../../connectedComponents/AuthNotification';
import ImageAttributtion from '../../components/ImageAttribution';

import './SplitContainer.scss';

const SplitContainer = ({
    children,
    secondary,
    header,
    shouldShowSecondaryPanel,
    usesNewStyles,
    lateralImage,
    onLoadComponent,
    shouldUseFullWidth,
}) => {
    const containerClasses = classNames('split-container', {
        'split-container--new-styles': usesNewStyles,
        'split-container--full-width': shouldUseFullWidth,
    });
    let secondaryPanel = null;

    useEffect(() => {
        onLoadComponent && onLoadComponent();
    }, [onLoadComponent]);

    if (shouldShowSecondaryPanel) {
        const { imageBgClass, attribution } = lateralImage;

        const backgroundClasses = classNames('split-container__bg', {
            [imageBgClass]: imageBgClass,
        });

        secondaryPanel = (
            <div className="split-container__secondary">
                {secondary}

                {imageBgClass && !isEmpty(attribution) && (
                    <>
                        <div key={imageBgClass} className={backgroundClasses} />

                        <ImageAttributtion
                            iamgeBgClass={imageBgClass}
                            attribution={attribution}
                        />
                    </>
                )}
            </div>
        );
    }

    return (
        <div className={containerClasses}>
            <div className="split-container__primary">
                <div className="split-container__content">
                    {header && header}

                    <ConnectedAuthNotification />

                    {children}
                </div>
            </div>

            {secondaryPanel}
        </div>
    );
};

SplitContainer.defaultProps = {
    children: null,
    secondary: null,
    header: null,
    shouldShowSecondaryPanel: false,
    usesNewStyles: false,
    lateralImage: { imageBgClass: '', attribution: {} },
    shouldUseFullWidth: false,
};

export default SplitContainer;
